import React, { useState, useRef } from 'react';
import { TextField, Button, Card, CardHeader, CardContent, Grid, Typography, Checkbox, Select, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LogoUploader from '../components/image-upload';
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
    foo: {
        width: '100%'
    },
    headers: {
        margin: '10px 0'
    }

}));

const UpdateCalc = props => {

    const [objectLabel, setObjectLabel] = useState('');
    const [objectMaxYears, setObjectMaxYears] = useState(1);
    const [objectIntrest, setObjectIntrest] = useState('');
    //const [copySuccess, setCopySuccess] = useState('');
    const textAreaRef = useRef(null);
    const [objectProgramLabel, setObjectProgramLabel] = useState('');
    const [objectProgramIntrest, setObjectProgramIntrest] = useState('');
    const [partPaymentOptionsTitle, setPartPaymentOptionsTitle] = useState('');
    const [partPaymentOptionsInitalFee, setPartPaymentOptionsIntialFee] = useState('');
    const [partPaymentOptionsInvoiceFee, setPartPaymentOptionsInvoiceFee] = useState('');
    const [partPaymentOptionsMaxAmount, setPartPaymentOptionsMaxAmount] = useState('');
    const [partPaymentOptionsMinAmount, setPartPaymentOptionsMinAmount] = useState('');
    const [partPaymentOptionsTerm, setPartPaymentOptionsTerm] = useState(`Rörlig ränta ##intrest##, uppläggningsavgift ##initialFee## kr och administrationsavgift ##invoiceFee## kr per månad. För ett köp på ##amount## kr uppdelat på ##numberOfPayments## månatliga, lika stora betalningar blir den effektiva räntan ##effectiveInterestRate##. Totalt belopp att betala blir ##total## kr och månadsbeloppet  ##month## kr.
    <br/>
    Effektiv ränta = alla kostnader för delbetalningen omräknad till årsränta enligt Konsumentverkets riktlinjer.
    <br/>
    Klicka på Ansök nu och starta din ansökan genom att identifiera dig med BankID. Fyll i dina uppgifter, godkänn villkoren och klicka på Nästa. Du får svar direkt. Granska din ansökan en sista gång och signera med ditt BankID.`);
    const [partPaymentOptionsBuyNow, setPartPaymentOptionsBuyNow] = useState('');
    const [partPaymentOptionsMonth, setPartPaymentOptionsMonth] = useState('');
    const [partPaymentOptionsIntrest, setPartPaymentOptionsIntrest] = useState('');
    //add all state for 
    /**partPaymentOptions */

    const classes = useStyles();

    const updateSliders = sliders => {

        const handleSliderChange = (e, item, key) => {
            props.setConfig({ ...props.config, sliders: { ...props.config.sliders, [item]: { ...props.config.sliders[item], [key]: e.target.value } } })
        }

        const translateSliders = item => {
            let translation = '';
            switch (item) {
                case 'price':
                    translation = 'Pris';
                    break;
                case 'downPayment':
                    translation = 'Handpenning';
                    break;
                case 'years':
                    translation = 'År';
                    break;
                case 'intrest':
                    translation = 'Ränta';
                    break;
                default:
                    translation = '';
                    break;
            }
            return translation;
        }

        return (<div style={{
            root: {
                flexGrow: 1,
            }
        }}>{Object.keys(sliders).map(item => {
            return (<Grid container spacing={3} key={item}>
                <Grid style={{ width: '12%' }}><strong style={{ padding: '12px', display: 'block' }}>{translateSliders(item)}</strong></Grid>

                {typeof props.config.sliders[item].min !== 'undefined' && (
                    <Grid item>
                        <TextField label={'Minvärde'} value={props.config.sliders[item].min} onChange={e => handleSliderChange(e, item, 'min')}>
                        </TextField></Grid>)}


                {typeof props.config.sliders[item].max !== 'undefined' && (<Grid item>
                    <TextField label={'Maxvärde'} defaultValue={props.config.sliders[item].max}
                        onChange={e => handleSliderChange(e, item, 'max')}></TextField>
                </Grid>)}


                {typeof props.config.sliders[item].step !== 'undefined' && (<Grid item><TextField label={'Steg'} value={props.config.sliders[item].step}
                    onChange={e => handleSliderChange(e, item, 'step')}></TextField> </Grid>)}

            </Grid>)
        })}</div>)
    }

    const updateMisc = misc => {

        const setLabel = key => {
            let label = '';
            switch (key) {
                case 'invoiceFee':
                    label = 'Fakturaavgift';
                    break;
                case 'initialFee':
                    label = 'Upplägningsavgift';
                    break;
                case 'defaultPrice':
                    label = 'Standardbelopp';
                    break;
                case 'defaultIntrest':
                    label = 'Standardränta';
                    break;
                case 'defaultYear':
                    label = 'Löptid (i månander)';
                    break;
                case 'selectOrRadio':
                    label = 'Lista';
                    break;
                case 'color':
                    label = 'Textfärg';
                    break;
                case 'backgroundColor':
                    label = 'Bakgrundsfärg';
                    break;
                case 'applyButton':
                    label = 'Färg Ansökningsknapp'
                    break;
                default:
                    label = '';
            }
            return label;
        }

        const getVisibilityLabel = raw => {
            let label = '';
            switch (raw) {
                case 'applyButton':
                    label = 'Ansökningsknapp';
                    break;
                case 'years':
                    label = 'År';
                    break;
                case 'downPayment':
                    label = 'Handpenning';
                    break;
                case 'intrest':
                    label = 'Ränta';
                    break;
                case 'price':
                    label = 'Pris';
                    break;
                default:
                    label = '';
                    break;

            }
            return label;
        }

        const renderVisibilityOptions = (options) => {
            const opts = [{ v: 0, k: 'Ej Synlig' }, { v: 1, k: 'Bara värdet' }, { v: 2, k: 'Synlig' }];
            const handleSelectedVisibility = (element, visibility) => {
                props.setConfig({ ...props.config, misc: { ...props.config.misc, visibility: { ...props.config.misc.visibility, [element]: Number(visibility) } } });
            }
            const elements = [];

            for (const [key, value] of Object.entries(options)) {
                elements.push(<div style={{ display: 'flex', width: 300, justifyContent: 'space-between' }} key={key}>
                    <label>{getVisibilityLabel(key)}</label>
                    <Select
                        value={props.config.misc.visibility[key]}
                        onChange={e => handleSelectedVisibility(key, e.target.value)}>
                        {opts.map((item, index) => {
                            return <MenuItem key={item.v + index} value={item.v}>{item.k}</MenuItem>
                        })}
                    </Select>

                </div>)
            }
            return elements;
        }

        return (
            <Grid container spacing={8}>
                {Object.keys(misc).map(item => {
                    return <Grid key={item} item>

                        {item !== 'visibility' && item !== 'mortgageType' && item !== 'logo' && item !== 'logoText' && <TextField key={item} label={setLabel(item)} value={misc[item]} onChange={e => {
                            props.setConfig({ ...props.config, misc: { ...props.config.misc, [item]: e.target.value } })
                        }} ></TextField>}
                    </Grid>
                })}
                <Grid item>

                    <Typography className={classes.headers} variant="h6">Grundinställningar Synlighet</Typography>{renderVisibilityOptions(misc['visibility'])}

                </Grid>

                <Grid item>
                    <Typography className={classes.headers} variant="h6">Välj Logo</Typography>
                    <div style={{ maxHeight: 450, overflow: 'auto' }}>
                        <LogoUploader config={props.config} setConfig={props.setConfig} ></LogoUploader>
                    </div>
                    <TextField label="Text bredvid logon" style={{ width: "100%" }}
                        multiline rows={4} variant="outlined"
                        defaultValue={props.config.misc.logoText}
                        onChange={e => props.setConfig({ ...props.config, misc: { ...props.config.misc, logoText: e.target.value } })}>
                    </TextField>
                </Grid>


            </Grid>)

    }

    const updateText = () => {

        const handleTextChange = e => {
            let text = e.target.value.split('##');
            let newTextObject = { text: {} };

            for (let i = 0; i < text.length; i++) {
                switch (text[i]) {
                    case 'intrest':
                        newTextObject = { ...props.config, text: { ...newTextObject.text, intrest: text[i] } }
                        break;
                    case 'total':
                        newTextObject = { ...props.config, text: { ...newTextObject.text, total: text[i] } }
                        break;
                    case 'subTotal':
                        newTextObject = { ...props.config, text: { ...newTextObject.text, subTotal: text[i] } }
                        break;
                    case 'numberOfPayments':
                        newTextObject = { ...props.config, text: { ...newTextObject.text, numberOfPayments: text[i] } }
                        break;
                    case 'effectiveInterestRate':
                        newTextObject = { ...props.config, text: { ...newTextObject.text, effectiveInterestRate: text[i] } }
                        break;
                    case 'invoiceFee':
                        newTextObject = { ...props.config, text: { ...newTextObject.text, invoiceFee: text[i] } }
                        break;
                    case 'initialFee':
                        newTextObject = { ...props.config, text: { ...newTextObject.text, initialFee: text[i] } }
                        break;
                    case 'amount':
                        newTextObject = { ...props.config, text: { ...newTextObject.text, amount: text[i] } }
                        break;
                    case 'month':
                        newTextObject = { ...props.config, text: { ...newTextObject.text, month: text[i] } }
                        break;
                    default:
                        newTextObject = { ...props.config, text: { ...newTextObject.text, ['part' + i]: text[i] } }
                        break
                }
            }

            props.setConfig({ ...newTextObject, text: { ...newTextObject.text, raw: e.target.value } })
        }

        return (<div><TextField style={{ width: "100%" }} multiline rows={8} variant="outlined" defaultValue={props.config.text.raw} onChange={handleTextChange}></TextField></div>)

    }

    const updateLabels = labels => {
        return (<Grid container spacing={4}>{Object.keys(labels).map(item => {
            return <Grid item key={item}><TextField key={item} defaultValue={labels[item]} onChange={e => {
                props.setConfig({ ...props.config, label: { ...props.config.label, [item]: e.target.value } })
            }} ></TextField></Grid>
        })}</Grid>)
    }

    const handleObjectChange = (object, e, id, key, type = 'text') => {

        let val = '';
        if (type === 'cb') {
            val = e.target.checked;
        } else if (type === 'toc') {

            let text = e.target.value.split('##');

            let newTextObject = { text: {}, raw: '' };

            for (let i = 0; i < text.length; i++) {
                switch (text[i]) {
                    case 'intrest':
                        newTextObject = { text: { ...newTextObject.text, intrest: text[i] } }
                        break;
                    case 'total':
                        newTextObject = { text: { ...newTextObject.text, total: text[i] } }
                        break;
                    case 'subTotal':
                        newTextObject = { text: { ...newTextObject.text, subTotal: text[i] } }
                        break;
                    case 'numberOfPayments':
                        newTextObject = { text: { ...newTextObject.text, numberOfPayments: text[i] } }
                        break;
                    case 'effectiveInterestRate':
                        newTextObject = { text: { ...newTextObject.text, effectiveInterestRate: text[i] } }
                        break;
                    case 'invoiceFee':
                        newTextObject = { text: { ...newTextObject.text, invoiceFee: text[i] } }
                        break;
                    case 'initialFee':
                        newTextObject = { text: { ...newTextObject.text, initialFee: text[i] } }
                        break;
                    case 'amount':
                        newTextObject = { text: { ...newTextObject.text, amount: text[i] } }
                        break;
                    case 'month':
                        newTextObject = { text: { ...newTextObject.text, month: text[i] } }
                        break;
                    default:
                        newTextObject = { text: { ...newTextObject.text, ['part' + i]: text[i] } }
                        break
                }
            }
            val = { ...newTextObject, raw: e.target.value }

        } else {
            val = e.target.value;
        }

        let updatedObjectList = props.config.lists[object].map(item => {
            if (item.id === id) {
                item[key] = val;
            }
            return item
        });
        props.setConfig({ ...props.config, lists: { ...props.config.lists, [object]: [...updatedObjectList] } });

    }

    const getId = (list) => {
        if (list) {
            return Math.max(...list.map(i => i.id)) + 1;
        }
        return 1;
    }

    const addObjectType = object => {
        props.setConfig({
            ...props.config, lists: {
                ...props.config.lists,
                objectType: [...props.config.lists[object],
                { id: getId(props.config.lists[object]), label: objectLabel, maxYears: objectMaxYears, intrest: objectIntrest }
                ]
            }
        })
    }

    const addObjectProgram = object => {
        props.setConfig({
            ...props.config, lists: {
                ...props.config.lists,
                [object]: [...props.config.lists[object],
                { id: getId(props.config.lists[object]), label: objectProgramLabel, intrest: objectProgramIntrest }
                ]
            }
        })
    }

    const removeObjectType = (object, id) => {
        props.setConfig({ ...props.config, lists: { ...props.config.lists, [object]: props.config.lists[object].filter(item => item.id !== id) } })
    }

    const addOPartyPayment = object => {

        let text = partPaymentOptionsTerm.split('##');
        let newTextObject = { text: {}, raw: '' };


        for (let i = 0; i < text.length; i++) {
            switch (text[i]) {
                case 'intrest':
                    newTextObject = { text: { ...newTextObject.text, intrest: text[i] } }
                    break;
                case 'total':
                    newTextObject = { text: { ...newTextObject.text, total: text[i] } }
                    break;
                case 'subTotal':
                    newTextObject = { text: { ...newTextObject.text, subTotal: text[i] } }
                    break;
                case 'numberOfPayments':
                    newTextObject = { text: { ...newTextObject.text, numberOfPayments: text[i] } }
                    break;
                case 'effectiveInterestRate':
                    newTextObject = { text: { ...newTextObject.text, effectiveInterestRate: text[i] } }
                    break;
                case 'invoiceFee':
                    newTextObject = { text: { ...newTextObject.text, invoiceFee: text[i] } }
                    break;
                case 'initialFee':
                    newTextObject = { text: { ...newTextObject.text, initialFee: text[i] } }
                    break;
                case 'amount':
                    newTextObject = { text: { ...newTextObject.text, amount: text[i] } }
                    break;
                case 'month':
                    newTextObject = { text: { ...newTextObject.text, month: text[i] } }
                    break;
                default:
                    newTextObject = { text: { ...newTextObject.text, ['part' + i]: text[i] } }
                    break
            }
        }

        props.setConfig({
            ...props.config, lists: {
                ...props.config.lists,
                [object]: [...props.config.lists[object],
                {
                    id: getId(props.config.lists[object]),
                    title: partPaymentOptionsTitle,
                    intrest: partPaymentOptionsIntrest,
                    buyNow: partPaymentOptionsBuyNow,
                    month: partPaymentOptionsMonth,
                    maxAmount: partPaymentOptionsMaxAmount,
                    minAmount: partPaymentOptionsMinAmount,
                    initialFee: partPaymentOptionsInitalFee,
                    invoiceFee: partPaymentOptionsInvoiceFee,
                    terms: { ...newTextObject, raw: partPaymentOptionsTerm }
                }]
            }
        })
    }

    const copyIframeCode = () => {
        textAreaRef.current.select();
        document.execCommand('copy');
        //setCopySuccess('Copied!');
    }

    const renderObjectTypeList = objectList => {

        return (<Grid>
            {objectList.map(item => {

                return (<Grid container spacing={4} key={item.id}>
                    <Grid item>
                        {typeof item.label !== 'undefined' && <TextField value={item.label} label={'Titel'} onChange={e => handleObjectChange('objectType', e, item.id, 'label')}></TextField>}
                    </Grid>
                    <Grid item>
                        {typeof item.maxYears !== 'undefined' && <TextField label={'Max antal år'} value={item.maxYears} onChange={e => handleObjectChange('objectType', e, item.id, 'maxYears')}></TextField>}
                    </Grid>
                    <Grid item>
                        {typeof item.intrest !== 'undefined' && <TextField label={'Påverkan på ränta'} value={item.intrest} onChange={e => handleObjectChange('objectType', e, item.id, 'intrest')}></TextField>}
                    </Grid>
                    <Grid item>
                        <Button variant="contained" onClick={e => removeObjectType('objectType', item.id)}>Ta bort</Button>
                    </Grid>
                </Grid>)
            })}
            <Grid container spacing={4}>
                <Grid item><TextField label={'Titel'} onChange={e => setObjectLabel(e.target.value)}></TextField></Grid>
                <Grid item><TextField label={'Max antal år (ex 15)'} onChange={e => setObjectMaxYears(e.target.value)}></TextField></Grid>
                <Grid item><TextField label={'Påverkan ränta (ex -0.5)'} defaultValue={'0'} onChange={e => setObjectIntrest(e.target.value)}></TextField></Grid>
                <Grid item><Button onClick={e => addObjectType('objectType')} variant="contained">Lägg till</Button></Grid>
            </Grid>

        </Grid>)

    }

    const updateCustomerProgram = programList => {
        return (<div>
            {programList.map(item => {

                return (<Grid container spacing={3} key={item.id}>
                    {typeof item.label !== 'undefined' && <Grid item><TextField value={item.label} label={'Titel'}
                        onChange={e => handleObjectChange('customerProgram', e, item.id, 'label')}></TextField></Grid>}
                    {typeof item.intrest !== 'undefined' && <Grid item><TextField label={'Påverkan ränta'} value={item.intrest}
                        onChange={e => handleObjectChange('customerProgram', e, item.id, 'intrest')}></TextField></Grid>}
                    <Grid item>
                        <Button variant="contained" onClick={e => removeObjectType('customerProgram', item.id)}>Ta bort</Button>
                    </Grid>
                </Grid>)
            })}
            <Grid container spacing={4}>
                <Grid item><TextField label={'Titel'} onChange={e => setObjectProgramLabel(e.target.value)}></TextField></Grid>
                <Grid item><TextField label={'Påverkan ränta (ex -0.5)'} defaultValue={'0'} onChange={e => setObjectProgramIntrest(e.target.value)}></TextField></Grid>
                <Grid item>
                    <Button variant="contained" onClick={e => addObjectProgram('customerProgram')}>Lägg till</Button>
                </Grid>
            </Grid>

        </div>)

    }

    const renderPartPayment = partPaymentList => {
        return (<div>
            {partPaymentList.map(item => {
                return (
                    <div key={item.id + item.title}><Grid container spacing={3} key={item.id}>
                        <Grid item>
                            {typeof item.title !== 'undefined' && <TextField value={item.title} label={'Titel'} onChange={e => handleObjectChange('partPaymentOptions', e, item.id, 'title')}></TextField>}
                        </Grid>
                        <Grid item>
                            {typeof item.buyNow !== 'undefined' && <><label>Betala direkt</label> <Checkbox checked={Boolean(item.buyNow)} value={item.buyNow} onChange={e => handleObjectChange('partPaymentOptions', e, item.id, 'buyNow', 'cb')}></Checkbox></>}
                        </Grid>
                        <Grid item>
                            {typeof item.month !== 'undefined' && <TextField label={'Månader'} value={item.month} onChange={e => handleObjectChange('partPaymentOptions', e, item.id, 'month')}></TextField>}
                        </Grid>
                        <Grid item>
                            {typeof item.intrest !== 'undefined' && <TextField label={'Ränta'} value={item.intrest} onChange={e => handleObjectChange('partPaymentOptions', e, item.id, 'intrest')}></TextField>}
                        </Grid>
                        <Grid item>
                            {typeof item.initialFee !== 'undefined' && <TextField label={'Uppl.avg'} value={item.initialFee} onChange={e => handleObjectChange('partPaymentOptions', e, item.id, 'initialFee')}></TextField>}
                        </Grid>
                        <Grid item>
                            {typeof item.invoiceFee !== 'undefined' && <TextField label={'Adm.avg'} value={item.invoiceFee} onChange={e => handleObjectChange('partPaymentOptions', e, item.id, 'invoiceFee')}></TextField>}
                        </Grid>
                        <Grid item>
                            {typeof item.maxAmount !== 'undefined' && <TextField label={'Maxbelopp'} value={item.maxAmount} onChange={e => handleObjectChange('partPaymentOptions', e, item.id, 'maxAmount')}></TextField>}
                        </Grid>
                        <Grid item>
                            {typeof item.minAmount !== 'undefined' && <TextField label={'Minibelopp'} value={item.minAmount} onChange={e => handleObjectChange('partPaymentOptions', e, item.id, 'minAmount')}></TextField>}
                        </Grid>
                        <Grid item>
                            <Button variant="contained" onClick={e => removeObjectType('partPaymentOptions', item.id)}>Ta bort</Button>
                        </Grid>
                    </Grid>
                        <Grid item>
                            <Typography className={classes.headers} variant="h6">Vilkorstext</Typography>
                            <div style={{ marginBottom: "20px" }}>
                                <TextField style={{ width: "600px" }} multiline rows={8} variant="outlined" defaultValue={item.terms.raw} onChange={e => handleObjectChange('partPaymentOptions', e, item.id, 'terms', 'toc')}></TextField>
                            </div>
                        </Grid>
                    </div>
                )
            })}
            <Grid container spacing={4}>
                <Grid item>
                    <TextField label={'Titel'} onChange={e => setPartPaymentOptionsTitle(e.target.value)}></TextField>
                    <Typography className={classes.headers} variant="h6">Vilkorstext</Typography>
                    <div style={{ marginBottom: "20px" }}>
                        <TextField style={{ width: "600px" }} multiline rows={8} variant="outlined" defaultValue={partPaymentOptionsTerm} onChange={e => setPartPaymentOptionsTerm(e.target.value)}></TextField>
                    </div>
                </Grid>
                <Grid item><label>Betala direkt</label><Checkbox label={'Betala direkt'} onChange={e => setPartPaymentOptionsBuyNow(e.target.checked)}></Checkbox></Grid>
                <Grid item><TextField type='number' label={'Månader'} defaultValue={''} onChange={e => setPartPaymentOptionsMonth(e.target.value)}></TextField></Grid>
                <Grid item><TextField type='number' label={'Ränta'} defaultValue={''} onChange={e => setPartPaymentOptionsIntrest(e.target.value)}></TextField></Grid>
                <Grid item><TextField type='number' label={'Uppl.avg'} defaultValue={''} onChange={e => setPartPaymentOptionsIntialFee(e.target.value)}></TextField></Grid>
                <Grid item><TextField type='number' label={'Adm.avg'} defaultValue={''} onChange={e => setPartPaymentOptionsInvoiceFee(e.target.value)}></TextField></Grid>
                <Grid item><TextField type='number' label={'Maxbelopp'} defaultValue={'100000'} onChange={e => setPartPaymentOptionsMaxAmount(e.target.value)}></TextField></Grid>
                <Grid item><TextField type='number' label={'Minibelopp'} defaultValue={'10000'} onChange={e => setPartPaymentOptionsMinAmount(e.target.value)}></TextField></Grid>
                <Grid item>
                    <Button variant="contained" onClick={e => addOPartyPayment('partPaymentOptions')}>Lägg till</Button>
                </Grid>
            </Grid>

        </div>)
    }

    const updateApplyButton = button => {
        return (<Grid container spacing={4}>{Object.keys(button).map(item => {
            return <Grid item key={item}><TextField label={item === 'title' ? 'Titel' : 'Länk'} key={item} value={props.config.applay[item]} onChange={e => {
                props.setConfig({ ...props.config, applay: { ...props.config.applay, [item]: e.target.value } })
            }} ></TextField></Grid>
        })}</Grid>)
    }


    const saveForm = () => {
        if (!!props.config.lists.partPaymentOptions) {
            const sortedPaymentOptions = props.config.lists.partPaymentOptions.sort((a, b) => {
                if (Number(a.month) === Number(b.month)) {
                    return Number(a.buyNow) > Number(b.buyNow) ? -1 : 1
                } else {
                    return Number(a.month) < Number(b.month) ? -1 : 1
                }
            });
            const sortedConfigObject = { ...props.config, lists: { ...props.config.lists, partPaymentOptions: [...sortedPaymentOptions] } };
            props.setConfig(sortedConfigObject);
            axios.post('https://everydaycard.se/api', {
                update_calc: true, id: props.pageId, data: sortedConfigObject
            }).then(response => {
            })
        } else {
            axios.post('https://everydaycard.se/api', {
                update_calc: true, id: props.pageId, data: { ...props.config }

            }).then(response => {
            })
        }



    }

    return (<Card className={classes.foo}>
        <CardHeader title={'Updatera kalkylatorn'}></CardHeader>
        <CardContent>
            <Typography className={classes.headers} variant="h6">Rubriker</Typography>
            {updateLabels(props.config.label)}

            {props.pageType !== 4 && <Typography className={classes.headers} variant="h6">Sliders</Typography>}
            {props.pageType !== 4 && updateSliders(props.config.sliders)}

            {!!props.config.lists.objectType.length && <Typography className={classes.headers} variant="h6">Objekt Typer</Typography>}
            {!!props.config.lists.objectType.length && renderObjectTypeList(props.config.lists.objectType)}

            {!!props.config.lists.customerProgram.length && <Typography className={classes.headers} variant="h6">Kundprogram</Typography>}
            {!!props.config.lists.customerProgram.length && updateCustomerProgram(props.config.lists.customerProgram)}

            {!!props.config.lists.partPaymentOptions && props.config.lists.partPaymentOptions.length && <Typography className={classes.headers} variant="h6">Kundprogram</Typography>}
            {!!props.config.lists.partPaymentOptions && props.config.lists.partPaymentOptions.length && renderPartPayment(props.config.lists.partPaymentOptions)}

            <Typography className={classes.headers} variant="h6">Vilkorstext (Grundinställning)</Typography>
            {updateText()}

            <Typography className={classes.headers} variant="h6">Grundinställningar</Typography>
            {updateMisc(props.config.misc)}

            <Typography className={classes.headers} variant="h6">Ansökan</Typography>
            {updateApplyButton(props.config.applay)}


            <Button style={{ marginTop: '20px', marginBottom: '20px', marginRight: '10px' }} variant="contained" onClick={e => saveForm()}>Spara</Button>

            <Button style={{ marginTop: '20px', marginBottom: '20px', marginRight: '10px' }} variant="contained" onClick={e => window.open(`https://everydaycard.se/apinew-calc/?id=${props.pageId}&type=${props.pageType}`, "_blank")}>Förhandsgranska</Button>
            <Button style={{ marginTop: '20px', marginBottom: '20px' }} variant="contained" onClick={e => copyIframeCode()}>Kopiera IFrame kod</Button>

            <textarea
                ref={textAreaRef}
                style={{
                    width: '1px',
                    height: '1px',
                    background: 'white',
                    color: 'white',
                    border: 'none',
                    padding: 0
                }}
                onChange={e => null}
                value={`<iframe 
                src="https://everydaycard.se/apinew-calc/?id=${props.pageId}&type=${props.pageType}&invoicefee=${props.config.misc.invoiceFee}&initialfee=${props.config.misc.initialFee}&price=${props.config.misc.defaultPrice}&intrest=${props.config.misc.defaultIntrest}&years=${props.config.sliders.years && props.config.sliders.years.min ? props.config.sliders.years.min : 5}&downpayment=${props.config.sliders.downPayment && props.config.sliders.downPayment.min ? props.config.sliders.downPayment.min : 0}" width="550" height="880" frameborder="0" allowfullscreen="true" marginwidth="0" marginheight="0" vspace="0" hspace="0" style="border:0;"></iframe>`
                }
            />
        </CardContent>

    </Card>)

}

export default UpdateCalc;